(() => {
  const gradeTokens = new Set(['psa', 'cgc', 'bgs', 'sgc', 'ace']);

  function normalizeQuery(value) {
    const query = String(value || '')
      .replace(/\s+/g, ' ')
      .trim();

    if (!query || query.includes('#')) return query;

    const parts = query.split(' ');
    if (parts.length < 2) return query;

    const last = parts[parts.length - 1];
    const previous = parts[parts.length - 2].toLocaleLowerCase('tr-TR');
    const looksLikeCardNumber = /^(?:[a-z]{1,6})?\d{1,4}[a-z]?$/i.test(last);

    if (!looksLikeCardNumber || gradeTokens.has(previous)) return query;

    parts[parts.length - 1] = `#${last}`;
    return parts.join(' ');
  }

  function bindSearchForm(form) {
    if (!form || form.dataset.kartologSearchRedirect === '1') return;
    const input = form.querySelector('input[name="q"], input[type="search"]');
    if (!input) return;

    form.dataset.kartologSearchRedirect = '1';
    form.addEventListener('submit', (event) => {
      const query = normalizeQuery(input.value);
      if (!query) return;
      event.preventDefault();
      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=none&options%5Bunavailable_products%5D=last`;
    });
  }

  function bindAll() {
    document
      .querySelectorAll('form[action="/search"], form[action$="/search"]')
      .forEach(bindSearchForm);
  }

  document.addEventListener('DOMContentLoaded', bindAll);
  bindAll();
})();
